/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import moment from 'moment';
import {Form, Input, Select, Button, Row, Col, message, DatePicker} from 'antd';
import {add, update, sKeylist, account_type, getRoleListByCondition, giveAcount, linkMandetail, insertSecondChild, getSecondChildAccount} from '../../service/customerManagement/linkman';
import {DmsTab} from 'Components';
import {nameValidator, checkPhone, checkTel, checkWeiXin, checkQQ} from '../../utils/regexp.js';

const FormItem = Form.Item;
import {showSpin, hideSpin, openNotice} from 'Utils';

class AddChildAccount extends React.Component {
    constructor(props) {
        super(props);
        this.from = props.location.query.from || '';
        this.customerDetail = JSON.parse(window.sessionStorage.getItem('customer_detail') || '{}');
        this.state = {
            customerManagementId: this.customerDetail.id,
            detail: {},
            sex: [],
            roleId: [],
        }
    }

    componentDidMount() {
        const self = this;
        this.mounted = true;
        sKeylist({sKey: 'sex'}).then(res => { //性别
            self.setState({sex: res.data})
        });
        if(self.from && self.from === 'customer') {
            getRoleListByCondition().then(res => { //二级客户子账户类型
                self.setState({roleId: res.data})
            });
        } else {
            account_type({id: 'roleId'}).then(res => { //账户类型
                self.setState({roleId: res.data})
            });
        }
        if (self.props.routeParams.linkmanId != 0) {
            linkMandetail(self.props.routeParams.linkmanId).then(res => {
                if (res.status) {
                    self.setState({
                        ...this.state,
                        detail: {...res.data, roleId: `${res.data.roleId}`}
                    })
                } else {
                    openNotice('error', '获取数据失败');
                    hashHistory.goBack()
                }
            });
        }
        if (self.props.routeParams.linkmanId == 0) {
            if(self.from && self.from === 'customer') { // 二级客户子账户
                getSecondChildAccount({fatherId: self.state.customerManagementId}).then(res => {
                    if (res.status) {
                        self.setState({
                            detail: {...self.state.detail, account: res.data}
                        })
                    }
                })
            } else {
                giveAcount(self.state.customerManagementId).then(res => {
                    if (res.status) {
                        self.setState({
                            detail: {...self.state.detail, account: res.data.account}
                        })
                    }
                })
            }
        }
    }

    /*取消*/
    cancelHandle() {
        hashHistory.goBack()
    }

    /*保存*/
    submitHandle() {
        const self = this;
        const {validateFields, getFieldsValue} = this.props.form;
        const {customerManagementId} = this.state;
        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue() //获取用户输入
            };
            let contactInfoList = [];
            Object.keys(data).forEach((key) => {
                if (key.match('ContactInfo')) {
                    data[key].length > 0 ? contactInfoList.push({
                        content: data[key], //联系方式内容 ,
                        type: parseInt(key.split('_')[1], 10), // (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
                    }) : null;
                    delete data[key]; //删除冗余数据
                }
            });
            // console.log(`你正在提交数据：${JSON.stringify(data)}`);
            showSpin();
            if(self.from && self.from === 'customer') { // 二级客户子账户
                //insertSecondChild
                let param = {...data, fatherId: customerManagementId, accountId: this.customerDetail.userId};
                if(this.props.routeParams.linkmanId != 0) {
                    param.id = this.props.routeParams.linkmanId;
                }
                insertSecondChild(param).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack();
                });
            } else {
                if (this.props.routeParams.linkmanId == 0) {
                    add({...data, fatherId: customerManagementId}).then(res => {
                        hideSpin();
                        message[res.status ? 'success' : 'error'](res.message);
                        res.status && hashHistory.goBack();
                    });
                } else {
                    update({...data, id: this.props.routeParams.linkmanId}).then(res => {
                        hideSpin();
                        message[res.status ? 'success' : 'error'](res.message);
                        res.status && hashHistory.goBack();
                    });
                }
            }

        })
    }

    render() {
        const {detail, sex, roleId} = this.state;
        const {getFieldDecorator} = this.props.form;
        return <div className="dms-body">
            <DmsTab options={this.props.routeParams.linkmanId == 0 ? ['新建子账户'] : ['编辑账户']} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Form layout="horizontal">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="姓名：" hasFeedback>
                                {getFieldDecorator('name', {
                                    initialValue: detail.name || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入姓名'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input placeholder="请输入姓名"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div id="sexBox">
                                <FormItem label="性别：" hasFeedback>
                                    {getFieldDecorator('sex', {
                                        initialValue: detail.sex ? detail.sex.toString() : '',
                                        rules: [
                                            {
                                                required: false,
                                                message: '请选择性别'
                                            },
                                        ]
                                    })(
                                        <Select style={{width: '100%'}}
                                                getPopupContainer={() => document.getElementById('sexBox')}>
                                            {
                                                sex.map((item, index) => {
                                                    return <Select.Option key={index + ''}
                                                                          value={item.sKey}>{item.name}</Select.Option>
                                                })
                                            }
                                        </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="部门：" hasFeedback>
                                {getFieldDecorator('dept', {
                                    initialValue: detail.dept || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入部门'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ]
                                })(<Input placeholder="请输入部门"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div id="roleBox">
                                <FormItem label="账户类型：" hasFeedback>
                                    {getFieldDecorator('roleId', {
                                        initialValue: !!detail.roleId ? detail.roleId.toString() : undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择账户类型'
                                            },
                                            {
                                                validator: nameValidator
                                            }
                                        ],
                                    })(
                                        <Select style={{width: '100%'}}
                                                placeholder="请选择账户类型"
                                                getPopupContainer={() => document.getElementById('roleBox')}>
                                            {
                                                roleId.map(function (ele, index) {
                                                    return <Select.Option key={index + ''}
                                                                          value={ele.id + ''}>{ele.name}</Select.Option>
                                                })
                                            }
                                        </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="手机：" hasFeedback>
                                {getFieldDecorator('phone', {
                                    initialValue: detail.phone || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入手机'
                                        },
                                        {
                                            validator: checkPhone
                                        }
                                    ]
                                })(<Input placeholder="手机号码"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="座机：" hasFeedback>
                                {getFieldDecorator('tel', {
                                    initialValue: detail.tel || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入座机'
                                        },
                                        {
                                            validator: checkTel
                                        }
                                    ]
                                })(<Input placeholder="座机号码"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <div id="birthdayBox">
                                <FormItem label="生日：" hasFeedback>
                                    {getFieldDecorator('birthday', {
                                        initialValue: detail.birthday ? moment((new Date(detail.birthday)), 'YYYY-MM-DD') : null,
                                        rules: [
                                            {
                                                required: false,
                                                message: '请输入选择生日'
                                            },
                                        ]
                                    })(<DatePicker style={{width: '100%'}}
                                                   getCalendarContainer={() => document.getElementById('birthdayBox')}/>)}
                                </FormItem>
                            </div>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="QQ：" hasFeedback>
                                {getFieldDecorator('qq', {
                                    initialValue: detail.qq || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入QQ'
                                        },
                                        {
                                            validator: checkQQ
                                        }
                                    ]
                                })(<Input placeholder="QQ"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="Email：" hasFeedback>
                                {getFieldDecorator('email', {
                                    initialValue: detail.email || '',
                                    rules: [
                                        {
                                            type: 'email',
                                            message: '请输入正确的邮箱号码'
                                        },
                                    ]
                                })(<Input placeholder="Email"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="微信：" hasFeedback>
                                {getFieldDecorator('weixin', {
                                    initialValue: detail.weixin || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入微信'
                                        },
                                        {
                                            validator: checkWeiXin
                                        }
                                    ]
                                })(<Input placeholder="WEIXIN"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="账号：" hasFeedback>
                                {getFieldDecorator('account', {
                                    initialValue: detail.account || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入账号'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input disabled/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="密码：" hasFeedback>
                                {getFieldDecorator('plainPassword', {
                                    initialValue: detail.plainPassword ? detail.plainPassword || '' : 'TG123456',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入密码'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input disabled/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <div id="checkAllId">
                                <FormItem label="是否查询全部订单权限：" hasFeedback>
                                    {getFieldDecorator('checkAll', {
                                        initialValue: detail.checkAll ? detail.checkAll.toString() : '',
                                        rules: [
                                            {
                                                required: false,
                                                message: '请选择权限'
                                            },
                                        ]
                                    })(
                                        <Select style={{width: '100%'}}
                                                getPopupContainer={() => document.getElementById('checkAllId')}>
                                            <Select.Option key={'Y'} value={'Y'}>{'是'}</Select.Option>
                                            <Select.Option key={'N'} value={'N'}>{'否'}</Select.Option>
                                        </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    }
}

export default Form.create()(AddChildAccount)



// WEBPACK FOOTER //
// ./src/routes/linkman/add.js